/**
 * UI控件库
 * @module UI
 */
;
(function(ui, $) {
    /**
 * <h3>pickerdate 日期选择器</h3>
 * <a href="../../ui_controls/bui.pickerdate.html" target="_blank">demo</a>
 * <p>日期选择器</p>
 * <h5>方法</h5>
 * {{#crossLink "bui.pickerdate/value"}}{{/crossLink}}: 设置日期 <br>
 * {{#crossLink "bui.pickerdate/min"}}{{/crossLink}}: 设置最小日期 <br>
 * {{#crossLink "bui.pickerdate/max"}}{{/crossLink}}: 设置最大日期 <br>
 * {{#crossLink "bui.pickerdate/reset"}}{{/crossLink}}: 重新渲染 <br>
 * {{#crossLink "bui.pickerdate/onChange"}}{{/crossLink}}: 日期变更事件回调<br>
 * {{#crossLink "bui.pickerdate/formatValue"}}{{/crossLink}}: 数据格式化方法 <br>
 * {{#crossLink "bui.pickerdate/cols"}}{{/crossLink}}: 设置分栏<br>
 *  @namespace bui
 *  @class pickerdate
 *  @constructor 
 *  @param {object}  option
 *  @param {string}  option.id [ 日期生成的位置id ]
 *  @param {string}  option.input [ 透明度,小数点 ]
 *  @param {boolean}  option.popup [ 是否弹出窗口 默认 true || false ]
 *  @param {boolean}  option.mask [ 是否显示遮罩 默认 true || false ]
 *  @param {string}  option.value [ 初始化第一个日期,日期格式 2015/8/10 9:00 ]
 *  @param {string|Date}  option.min [ 最小日期,日期格式 2015/8/10 9:00 ]
 *  @param {string|Date}  option.max [ 最大日期,日期格式 2015/8/10 9:00 ]
 *  @param {function}  option.formatValue [ 日期格式化 ]
 *  @param {object}  option.cols [ 分栏 ]
 *  @param {object}  option.cols.year    { value: [],displayValues:[] }
 *  @param {object}  option.cols.month   { value: [],displayValues:[] }
 *  @param {object}  option.cols.date    { value: [],displayValues:[] }
 *  @param {object}  option.cols.hour    { value: [],displayValues:[] }
 *  @param {object}  option.cols.minute  { value: [],displayValues:[] }
 *  @param {object}  option.cols.second  { value: [],displayValues:[] }
 *  @param {function} option.onChange [ 回调 ]
 *
 *  @example
 * 
        var input = $("#datepicker_input");
        var uiPickerdate = bui.pickerdate({
            handle:"#datepicker_input",
            value: '2015/8/10 9:00',
            min: '2014/4/5 9:00',
            max: '2016/4/5 10:00',
            onChange: function(value) {
                input.val(value);
            }
        });

 *
 */

    ui.pickerdate = (function() {
        function transformTime(d) {
            if (d && d.constructor == Date) {
                return d;
            }
            if (typeof d == 'string') {
                d.replace('-', '/');
                return new Date(d);
            }
            if (typeof d == 'number') {
                return new Date(d);
            }
            console.error('Failed to execute "transformTime" on Datepicker');
        }

        function Datepicker(option) {
            var opt = option || {};
            var dp = this,
                voidFunc = function() {},
                opt_handle,
                opt_minDate,
                opt_maxDate,
                opt_container,
                opt_onChange,
                opt_formatValue,
                columns,
                dateCol,
                timeCol,
                curValue, prevValue,
                uiDialog = null;

            var indexOfCol = {}
            var _formateDateOrder = [
                    "FullYear",
                    "Month",
                    "Date"
                ],
                _formateTimeOrder = [
                    "Hours",
                    "Minutes",
                    "Seconds"
                ],
                _formateOrderMap = {
                    "FullYear": "year",
                    "Month": "month",
                    "Date": "date",
                    "Hours": "hour",
                    "Minutes": "minute",
                    "Seconds": "second"
                },

                formateOrder = [];

            function getPickerDate(cols) {
                var d = new Date(0);
                formateOrder.forEach(function(type, i) {
                    d["set" + type](cols[indexOfCol[type]].value);
                });
                return d;
            }

            function dateToArray(date) {
                var d = transformTime(date);
                return formateOrder.map(function(type, i) {
                    return d["get" + type]();
                })
            }

            function formatValue(p, values, displayValues) {
                var s1 = dateCol.map(function(type, i) {
                        return parseInt(p.cols[indexOfCol[type]].value) + (type === 'Month' ? 1 : 0);
                    }).join('-'),
                    s2 = timeCol.map(function(type, i) {
                        var v = p.cols[indexOfCol[type]].value;
                        return ('0' + v).slice(-2);
                    }).join(':');
                return s1 + ' ' + s2;

            }
            this.config = {

            }
            this.option = function() {

            }

            /**
             * 设置分栏
             *  @method cols
             *  @param {object} cols [ {} ]
             *  @param {object} cols.year [ 'none' || 年份  ]
             *  @param {array}  cols.year.values [ 年份的值 ]
             *  @param {array}  cols.year.displayValues [ 年份的值对应的文本 ]
             *  @param {object} cols.month [ 'none' || 月份  ]
             *  @param {array}  cols.month.values [ 月份的值 ]
             *  @param {array}  cols.month.displayValues [ 月份的值对应的文本 ]
             *  @param {object} cols.date [ 'none' || 日  ]
             *  @param {array}  cols.date.values [ 日 ]
             *  @param {array}  cols.date.displayValues [ 日对应的文本 ]
             *  @param {object} cols.hour [ 'none' || 时  ]
             *  @param {array}  cols.hour.values [ 时 ]
             *  @param {array}  cols.hour.displayValues [ 时对应的文本 ]
             *  @param {object} cols.minute [ 'none' || 分  ]
             *  @param {array}  cols.minute.values [ 分 ]
             *  @param {array}  cols.minute.displayValues [ 分对应的文本 ]
             *  @param {object} cols.second [ 'none' || 秒  ]
             *  @param {array}  cols.second.values [ 秒 ]
             *  @param {array}  cols.second.displayValues [ 秒对应的文本 ]
             *  @example 
                
                //设置分栏
                uiPickedate.cols({
                    year: {
                        values: [2013, 2014, 2015],
                    },
                    hour: {
                        values: [8, 9, 10, 11, 13, 14, 15, 16, 17]
                    },
                    minute: {
                        values: [0, 30],
                        displayValues: ['00', '30']
                    },
                    second: 'none'
                });
                    
             */
            this.cols = function(cols) {
                cols = cols || {};
                dateCol = [];
                timeCol = [];
                columns = [];
                indexOfCol = {};
                formateOrder = [];
                _formateDateOrder.forEach(function(type, i) {
                    if (cols[_formateOrderMap[type]] !== 'none') {
                        formateOrder.push(type);
                        dateCol.push(type);
                    }
                });
                _formateTimeOrder.forEach(function(type, i) {
                        if (cols[_formateOrderMap[type]] !== 'none') {
                            formateOrder.push(type);
                            timeCol.push(type);
                        }
                    })
                    // format
                dateCol.forEach(function(type, i) {
                    indexOfCol[type] = columns.length;
                    columns.push(createColumn[type](cols[_formateOrderMap[type]]));
                })
                timeCol.forEach(function(type, i) {
                    if (i == 0 && dateCol.length != 0) {
                        columns.push(createColumn["Space"]());
                    } else {
                        columns.push(createColumn["Divider"]());
                    }
                    indexOfCol[type] = columns.length;
                    columns.push(createColumn[type](cols[_formateOrderMap[type]]));
                });
                if (dp.picker) {
                    dp.picker.params.cols = columns;
                    dp.picker.initialized = false;
                    dp.picker.init();
                }
            };
            this.id = function(container) {
                    if (container && !opt_container) {
                        opt_container = container;
                    }
                }
                /**
                 * 重新渲染
                 *  @method reset
                 *  @example 
                    
                    //设置某个日期
                    uiPickedate.reset();
                        
                 */
            this.reset = function() {
                if (dp.picker) {
                    dp.picker.initialized = false;
                    dp.picker.init();
                }
            }

            /**
             * 设置最小日期
             *  @method min
             *  @param {string} [min] [ 默认最小日期:'1960/01/01 00:00:00' ]
             *  @example 
                
                //设置最小日期
                uiPickedate.min('1960/01/01 00:00:00');
                    
             */
            this.min = function(min) {
                opt_minDate = transformTime(min || opt.min || '1960/01/01 00:00:00');
            };

            /**
             * 设置最大日期
             *  @method max
             *  @param {string} [max] [ 默认最大日期:'2030/01/01 00:00:00' ]
             *  @example 
                
                //设置最大日期
                uiPickedate.max('2030/01/01 00:00:00');
                    
             */
            this.max = function(max) {
                opt_maxDate = transformTime(max || opt.max || '2030/01/01 00:00:00');
            };

            /**
             * 设置某个日期
             *  @method value
             *  @param {string} [date] [ 日期格式:'2030/01/01 00:00:00' ]
             *  @example 
                
                //设置某个日期
                uiPickedate.value('2016/07/01 00:00:00');
                    
             */
            this.value = function(date) {
                var d = transformTime(date),
                    arr = dateToArray(d);
                dp.picker.setValue(arr, 0);
            }

            function _handleClick(argument) {
                if (uiDialog) {
                    uiDialog.open(function() {});
                    if (!_handleClick.hasOpen) {
                        _handleClick.hasOpen = true;
                        dp.reset();
                    }
                }
            }
            this.handle = function(handle) {
                if (handle && opt_handle !== handle) {
                    var hd = ui.obj(opt_handle);
                    if (hd) {
                        hd.off('click', _handleClick);
                    }
                    hd = ui.obj(handle)
                    if (hd) {
                        hd.on("click", _handleClick);
                    }
                    _handleClick.hasOpen = false;
                    opt_handle = handle;
                }
            }

            /**
             * 格式化后回调
             *  @method formatValue
             *  @param {function} [callback] [ 数据转换后回调 ]
             *  @example 
                
                //设置某个日期
                uiPickedate.formatValue(function(argument) {
                    // body...
                });
                    
             */
            this.formatValue = function(callback) {
                opt_formatValue = callback || formatValue;
            }

            /**
             * 日期改变的回调
             *  @method onChange
             *  @param {function} [callback] [ 日期改变实时监听回调 ]
             *  @example 
                
                //设置某个日期
                uiPickedate.onChange(function(value) {
                    // body...
                });
                    
             */
            this.onChange = function(callback) {
                opt_onChange = callback || voidFunc;
            }


            this.popup = function(opt) {
                var guid = ui.guid();
                opt.popup = opt.popup == false ? false : true;
                opt.mask = opt.mask == false ? false : true;
                opt.positon = opt.positon || "bottom";

                if (opt.popup && !uiDialog) {

                    opt_container = $('<div id="' + guid + '" class="bui-dialog"></div>').appendTo(document.body);

                    uiDialog = ui.dialog({
                        id: guid,
                        position: opt.positon,
                        mask: opt.mask,
                        onMask: function(argument) {
                            uiDialog.close();
                        }
                    });
                }
                return this;
            };

            /*
             * picker options
             */
            var opt_change = function(picker, type, nextType) {
                var date = getPickerDate(picker.cols),
                    min = opt_minDate['get' + type](),
                    max = opt_maxDate['get' + type](),
                    datetime = date.getTime(),
                    mintime = opt_minDate.getTime(),
                    maxtime = opt_maxDate.getTime()
                if (datetime < mintime && date['get' + type]() < min) {
                    picker.cols[indexOfCol[type]].setValue(min)
                    return;
                } else if (datetime > maxtime && date['get' + type]() > max) {
                    picker.cols[indexOfCol[type]].setValue(max)
                    return;
                }
                if (nextType && (datetime < mintime || datetime > maxtime)) {
                    picker.cols[indexOfCol[nextType]].onChange(picker);
                }
            }
            var createColumn = {};
            // FullYear
            createColumn["FullYear"] = function(colYear) {
                colYear = colYear || {
                    values: (function() {
                        var arr = [];
                        var min = opt_minDate.getFullYear(),
                            max = opt_maxDate.getFullYear();
                        for (var i = min; i <= max; i++) {
                            arr.push(i)
                        };
                        return arr;
                    })()
                };
                return {
                    values: colYear.values,
                    displayValues: colYear.displayValues,
                    onChange: function(picker, value, displayValue) {
                        opt_change(picker, 'FullYear', !!indexOfCol['Month'] ? 'Month' : '');
                    }
                }
            };
            // Month
            createColumn["Month"] = function(colMonth) {
                colMonth = colMonth || {
                    values: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
                    displayValues: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
                };
                return {
                    values: colMonth.values,
                    displayValues: colMonth.displayValues,
                    textAlign: 'right',
                    onChange: function(picker, value, displayValue) {
                        var daysInMonth = new Date(picker.cols[indexOfCol['FullYear']].value,
                                parseInt(picker.cols[indexOfCol['Month']].value) + 1,
                                0).getDate(),
                            arr = [];
                        for (var i = 1; i <= daysInMonth; i++) {
                            arr.push(i);
                        }
                        var dateCol = picker.cols[indexOfCol["Date"]]
                        if (dateCol.replaceValues) {
                            dateCol.replaceValues(arr, null, dateCol.value < daysInMonth ? dateCol.value : daysInMonth);
                        }
                        opt_change(picker, 'Month', !!indexOfCol['Date'] ? 'Date' : '');
                    }
                }
            };
            // Date
            createColumn["Date"] = function(colDate) {
                colDate = colDate || {
                    values: (function() {
                        var lengthOfDaysInMonth = 31,
                            arr = [];
                        do {
                            arr.unshift(lengthOfDaysInMonth);
                        } while (lengthOfDaysInMonth--);
                        return arr;
                    })()
                };
                return {
                    values: colDate.values,
                    displayValues: colDate.displayValues,
                    onChange: function(picker, value, displayValue) {
                        opt_change(picker, 'Date', !!indexOfCol['Hours'] ? 'Hours' : '');
                    }
                }
            };
            // Space divider
            createColumn["Space"] = function() {
                return {
                    divider: true,
                    content: '  '
                }
            };
            // Hours
            createColumn["Hours"] = function(colHours) {
                colHours = colHours || (function() {
                    var values = [],
                        displayValues = [];
                    for (var i = 0; i < 24; i++) {
                        values.push(i);
                        displayValues.push(('0' + i).slice(-2));
                    }
                    return {
                        values: values,
                        displayValues: displayValues
                    };
                })();
                return {
                    values: colHours.values,
                    displayValues: colHours.displayValues,
                    onChange: function(picker, value, displayValue) {
                        opt_change(picker, 'Hours', !!indexOfCol['Minutes'] ? 'Minutes' : '');
                    }
                }
            };
            // Divider
            createColumn["Divider"] = function() {
                return {
                    divider: true,
                    textAlign: 'center',
                    content: ':'
                }
            };
            // Minutes
            createColumn["Minutes"] = function(colMin) {
                colMin = colMin || (function() {
                    var values = [],
                        displayValues = [];
                    for (var i = 0; i < 60; i++) {
                        values.push(i);
                        displayValues.push(('0' + i).slice(-2));
                    }
                    return {
                        values: values,
                        displayValues: displayValues
                    };
                })();
                return {
                    values: colMin.values,
                    displayValues: colMin.displayValues,
                    onChange: function(picker, value, displayValue) {
                        opt_change(picker, 'Minutes', !!indexOfCol['Seconds'] ? 'Seconds' : '');
                    }
                }
            };
            // Seconds
            createColumn["Seconds"] = function(colSec) {
                colSec = colSec || (function() {
                    var values = [],
                        displayValues = [];
                    for (var i = 0; i < 24; i++) {
                        values.push(i);
                        displayValues.push(('0' + i).slice(-2));
                    }
                    return {
                        values: values,
                        displayValues: displayValues
                    };
                })();
                return {
                    values: colSec.values,
                    displayValues: colSec.displayValues,
                    onChange: function(picker, value, displayValue) {
                        opt_change(picker, 'Seconds');
                    }
                }
            };
            /*
             * init
             */
            dp.min(opt.min);
            dp.max(opt.max);
            dp.cols(opt.cols);
            dp.onChange(opt.onChange);
            dp.formatValue(opt.formatValue);
            dp.popup(opt);
            dp.id(opt.id);
            dp.handle(opt.handle);
            //初始化对话框

            dp.picker = ui.picker({
                container: opt_container,
                rotateEffect: true,
                value: dateToArray(opt.value ? transformTime(opt.value) : opt_minDate),
                onChange: function(picker, values, displayValues) {
                    var value = opt_formatValue(picker, values, displayValues);
                    if (curValue == value) {
                        return;
                    }
                    curValue = value;
                    opt_onChange(value);
                },
                cols: columns
            });


        }

        return function(opt) {
            return new Datepicker(opt);
        }
    })();

    return ui;

})(bui || {}, libs);